import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';

import { Observable } from 'rxjs';
import { AuthService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
  usr: Observable<firebase.User>;
  constructor(
    private authservice: AuthService
    ) {}

  ngOnInit() {
this.usr = this.authservice.usr;
 }


}
